import { useTranslation } from 'react-i18next';
import { Link, useSearchParams } from 'react-router-dom';
import { useEffect } from 'react';
import HamburgerIcon from '@assets/icons/menu-2.svg?react';
import ChevronDown from '@assets/icons/chevron-down.svg?react';
import Logo from '@assets/logo/baseunit_logo.svg?react';

export const Navbar = () => {
    const { t, i18n } = useTranslation();
    const [searchParams, setSearchParams] = useSearchParams();

    // Trigger language change based on URL
    useEffect(() => {
        const lang = searchParams.get('lang');
        if (lang && lang !== i18n.language) {
            i18n.changeLanguage(lang);
        }
    }, [searchParams, i18n]);

    // Trigger language change from user input via  drop-down
    const handleLanguageChange = (lang) => {
        i18n.changeLanguage(lang);
        setSearchParams({ 'lang': lang });
        closeDropdown();
    };

    // Close dropdown
    const closeDropdown = () => {
        const elem = document.activeElement;
        if (elem instanceof HTMLElement) {
            elem.blur();
        }
    };

    // Logo click
    const handleLogoClick = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    const languages = {
        de: { nativeName: 'DE' },
        en: { nativeName: 'EN' },
    };

    return (
        <div className="flex items-center h-16 bg-navbg">
            <div className="navbar h-full max-w-[1280px] mx-auto px-8 py-0">
                {/* Left part */}
                <div className="navbar-start">
                    {/* Responsive drop down for smaller screens */}
                    <div className="dropdown dropdown-start mr-4 lg:hidden">
                        <div
                            tabIndex={0}
                            role="button"
                            className="btn btn-md btn-neutral btn-outline"
                        >
                            <HamburgerIcon />
                        </div>
                        {/* Generous spacing for tapping on mobile */}
                        <ul
                            tabIndex={0}
                            className="dropdown-content menu menu-lg bg-navbgdd text-navtxt mt-2 p-2 space-y-4 shadow-dropdown rounded-box w-max"
                        >
                            <li><a href="#customers" onClick={closeDropdown}>{t('nav.customers')}</a></li>
                            <li><a href="#services" onClick={closeDropdown}>{t('nav.services')}</a></li>
                            <li><a href="#about" onClick={closeDropdown}>{t('nav.about')}</a></li>
                            <li><a href="#contact" onClick={closeDropdown}>{t('nav.contact')}</a></li>
                        </ul>
                    </div>
                    {/* Logo */}
                    <Link to="/" onClick={handleLogoClick}>
                        <Logo className="h-[24px] w-auto" />
                    </Link>
                </div>

                {/* Center part */}
                <div className="navbar-center hidden lg:flex font-normal">
                    <ul className="menu menu-lg menu-horizontal text-navtxt">
                        <li><a href="#customers">{t('nav.customers')}</a></li>
                        <li><a href="#services">{t('nav.services')}</a></li>
                        <li><a href="#about">{t('nav.about')}</a></li>
                        <li><a href="#contact">{t('nav.contact')}</a></li>
                    </ul>
                </div>

                {/* Right part */}
                <div className="navbar-end">
                    {/* Language drop down */}
                    <div className="dropdown dropdown-end">
                        <div
                            tabIndex={0}
                            role="button"
                            className="btn btn-md btn-neutral btn-outline"
                        >
                            {languages[i18n.language]?.nativeName || 'Language'}
                            <ChevronDown />
                        </div>
                        <ul
                            tabIndex={0}
                            className="dropdown-content menu menu-lg bg-navbgdd text-navtxt mt-2 p-2 space-y-4 shadow-dropdown rounded-box w-max lg:menu-md lg:space-y-1"
                        >
                            {Object.keys(languages).map((lang) => (
                                <li key={lang}>
                                    <button
                                        onClick={() => handleLanguageChange(lang)}
                                        className={i18n.language === lang ? 'font-bold' : ''}
                                    >
                                        {languages[lang].nativeName}
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};